import MenuDetailModal from 'features/MenuDetail/pages/MenuDetail';
import SubMenuDetailModal from 'features/MenuDetail/pages/SubMenuDetail';
import DisplaySubMenuGroupDetail from 'features/SubMenuList/pages/SubMenuGroupDetail';
import { MenuObject } from 'features/common/models';
import { useRef, useState } from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';

function DemoMenuBookEditor() {
  const [show, setShow] = useState(false);

  function handleOpen() {
    setShow(true);
  }

  function handleClose() {
    setShow(false);
  }

  return (
    <div>
      <Button onClick={handleOpen}>Open MenuBookEditor</Button>

      {show && <MenuBookEditorPopupDemo onClose={handleClose} />}
    </div>
  );
}

interface MenuBookEditorPopupDemoProps {
  onClose?: () => void;
}

function MenuBookEditorPopupDemo({ onClose }: MenuBookEditorPopupDemoProps) {
  const subMenuDetailModalRef = useRef<ModalProps>(SubMenuDetailModal);
  const menuDetailModalRef = useRef<ModalProps>(MenuDetailModal);
  const subMenuGroupDetailModalRef = useRef<ModalProps>(DisplaySubMenuGroupDetail);

  const handleOpenModalEditSubMenu = (sub_menu_id: number) => {
    if (subMenuDetailModalRef.current) {
      subMenuDetailModalRef.current.openModalExternal(sub_menu_id);
    }
  };

  const handleOpenModalEditMenu = (menu_id: number) => {
    if (menuDetailModalRef.current) {
      menuDetailModalRef.current.openModalExternal(menu_id);
    }
  };

  const handleOpenModalSubMenuGroupDetailMenu = (id: number) => {
    subMenuGroupDetailModalRef.current.openModalExternal(id);
  };

  const handleSubMenuCallback = (obj: MenuObject | undefined) => {
    console.log(obj);
  };

  const handleMenuCallback = (obj: MenuObject | undefined) => {
    console.log(obj);
  };

  const handleMenuModalClose = () => {
    if (menuDetailModalRef.current) {
      menuDetailModalRef.current.onReset();
    }
  };

  const handleSubMenuModalClose = () => {
    if (subMenuDetailModalRef.current) {
      subMenuDetailModalRef.current.onReset();
    }
  };

  const handleSubMenuGroupModalClose = () => {
    if (subMenuGroupDetailModalRef.current) {
      subMenuGroupDetailModalRef.current.onReset();
    }
  };

  function handleClose() {
    onClose && onClose();
  }

  return (
    <>
      <MenuDetailModal
        ref={menuDetailModalRef}
        onMenuModalClose={handleMenuModalClose}
        menuCallBack={handleMenuCallback}
      />
      <SubMenuDetailModal
        ref={subMenuDetailModalRef}
        onMenuModalClose={handleSubMenuModalClose}
        menuCallBack={handleSubMenuCallback}
      />
      <DisplaySubMenuGroupDetail
        ref={subMenuGroupDetailModalRef}
        onSubMenuGroupModalClose={handleSubMenuGroupModalClose}
      />

      <Modal size="xl" show backdrop="static" onHide={handleClose} centered>
        <Modal.Header closeButton>
          <div className="page-head-title bg-violet p-2 fw-bold" style={{ minWidth: '150px' }}>
            This is MenuBookEditor Popup
          </div>
        </Modal.Header>
        <Modal.Body>
          <div>
            <ul>
              <li className="mb-3">
                <Button onClick={() => handleOpenModalEditSubMenu(512)}>Edit Sub Menu 512</Button>
                &nbsp;
                <Button onClick={() => handleOpenModalEditSubMenu(219)}>Edit Sub Menu 219</Button>
              </li>
              <li className="mb-3">
                <Button
                  onClick={() => {
                    handleOpenModalEditMenu(1);
                  }}
                >
                  Edit Menu 1
                </Button>{' '}
                &nbsp;
                <Button
                  onClick={() => {
                    handleOpenModalEditMenu(2);
                  }}
                >
                  Edit Menu 2
                </Button>
              </li>

              <li className="mb-3">
                <Button
                  onClick={() => {
                    handleOpenModalSubMenuGroupDetailMenu(1);
                  }}
                >
                  Edit submenu group 1
                </Button>{' '}
                &nbsp;
                <Button
                  onClick={() => {
                    handleOpenModalSubMenuGroupDetailMenu(10);
                  }}
                >
                  Edit submenu group 10
                </Button>
              </li>
            </ul>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DemoMenuBookEditor;
